import { render } from "./xaxis-options.vue?vue&type=template&id=b53148da"
import script from "./xaxis-options.vue?vue&type=script&lang=js"
export * from "./xaxis-options.vue?vue&type=script&lang=js"

import "./xaxis-options.vue?vue&type=style&index=0&id=b53148da&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__